<template>
  <div class="title">
    <div class="t-left">
      <div class="l-top">
        <p class="text">{{ gettitle(title) }}</p>
        <p class="text2" v-if="extend">/</p>
        <p class="text2" v-if="extend">{{ extend }}</p>
        <div class="more-btn" @click="tomore" v-if="isMore">查看更多></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as methods from './method.js'
export default {
  name: 'scopetitle.textTitle3',
  props: {
    title: {
      type: [String, Object],
      default: ""
    },
    isMore: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extend: ''
    };
  },
  watch: {},
  methods: {
    ...methods
  },
  mounted() { },
};
</script>

<style scoped lang="scss">
@font-face {
  font-family: "YouSheBiaoTiHei";
  src: url("../../assets/fonts/YouSheBiaoTiHei.woff2");
}

.title {
  width: 435px;
  height: 40px;

}

.t-left {
  .l-top {
    width: 435px;
    height: 37.5px;
    background: url('../../assets/template4/title.png') no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 6px 0 0 60px;

    .text {
      font-family: Source Han Sans CN;
      font-weight: 500;
      font-size: 18px;
      color: #A9D3E4;
    }

    .text2 {
      margin-left: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: 12px;
      color: #8798AC;
      line-height: 12px;
    }
  }
}
</style>